import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const EInvoiceIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99805 6H2.92112C1.85904 6 0.998047 4.88071 0.998047 3.5C0.998047 2.11929 1.85904 1 2.92112 1H5.03651C5.56755 1 5.99805 1.55964 5.99805 2.25C5.99805 2.94036 5.56755 3.5 5.03651 3.5L2.92112 3.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.33337 1.33398H8.51517C10.6893 1.33398 11.7764 1.33398 12.5313 1.86588C12.7476 2.01827 12.9396 2.199 13.1016 2.40258C13.6667 3.1131 13.6667 4.13622 13.6667 6.18247V7.87945C13.6667 9.85492 13.6667 10.8426 13.3541 11.6315C12.8515 12.8997 11.7886 13.9 10.4411 14.373C9.60297 14.6673 8.55351 14.6673 6.45459 14.6673C5.25521 14.6673 4.65552 14.6673 4.17656 14.4992C3.40657 14.2289 2.79921 13.6573 2.51201 12.9326C2.33337 12.4818 2.33337 11.9174 2.33337 10.7885V8.00065"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6667 8C13.6667 9.22727 12.6717 10.2222 11.4445 10.2222C11.0006 10.2222 10.4773 10.1445 10.0457 10.2601C9.66233 10.3628 9.3628 10.6623 9.26007 11.0457C9.14447 11.4773 9.2222 12.0006 9.2222 12.4445C9.2222 13.6717 8.22727 14.6667 7 14.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
